import { type Key, memo, useState } from 'react';

import type { EmailTemplateFormValues } from './EmailTemplates.types.ts';

import EmailTemplates from './EmailTemplates';
import { useService } from './EmailTemplates.hooks.ts';
import { getEmailTemplateData } from './EmailTemplates.helpers.ts';

export const EmailTemplatesContainer = () => {
  const [selectedTemplateKeys, setSelectedTemplateKeys] = useState<React.Key[]>([]);
  const [openTemplateDrawer, setOpenTemplateDrawer] = useState<boolean>(false);
  const [emailTemplateId, setEmailTemplateId] = useState<number | null>(null);
  const { createMutation, updateMutation, deleteMutation, templates, isLoading } = useService({
    emailTemplateId,
  });

  const handleOpenTemplateDrawer = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    id: number | null,
  ) => {
    if (event) event.preventDefault();
    if (id === undefined) return;

    setEmailTemplateId(id);
    setOpenTemplateDrawer(true);
  };

  const handleCloseTemplateDrawer = () => {
    setEmailTemplateId(null);
    setOpenTemplateDrawer(false);
  };

  const handleSubmitTemplate = (values: EmailTemplateFormValues) => {
    const data = getEmailTemplateData(values);
    if (values?.id) {
      updateMutation.mutate({ data: { ...data, id: values.id } });
      handleCloseTemplateDrawer();
      return;
    }
    createMutation.mutate(data);
    handleCloseTemplateDrawer();
  };

  const handleDeleteTemplates = () => {
    const params = { ids: selectedTemplateKeys.map((key: Key) => Number(key)) };
    setEmailTemplateId(null);
    setSelectedTemplateKeys([]);
    deleteMutation.mutate(params);
  };

  return (
    <EmailTemplates
      templates={templates}
      isLoading={isLoading}
      openTemplateDrawer={openTemplateDrawer}
      onOpenTemplateDrawer={handleOpenTemplateDrawer}
      onCloseTemplateDrawer={handleCloseTemplateDrawer}
      onSubmitTemplate={handleSubmitTemplate}
      selectedTemplateKeys={selectedTemplateKeys}
      setSelectedTemplateKeys={setSelectedTemplateKeys}
      onDeleteTemplates={handleDeleteTemplates}
      emailTemplateId={emailTemplateId}
      itemsToDeleteCount={selectedTemplateKeys.length}
    />
  );
};

export default memo(EmailTemplatesContainer);
